import {
  createAccessService,
  GrantableAccessRole,
  ShareAccessRequest,
} from '@/services/shared/create-access-service';

export type GrantableCollectionRole = GrantableAccessRole;
export type ShareCollectionRequest = ShareAccessRequest;

const collectionAccess = createAccessService({
  pathSegment: 'collection-access',
  sentryContext: 'collection-access',
});

export const shareCollection = collectionAccess.share;
export const listCollectionShare = collectionAccess.listAccess;
export const updateCollectionRole = collectionAccess.updateRole;
export const revokeCollectionAccess = collectionAccess.revokeAccess;
